import { commentItems } from '@/mocks/home';

export default function CommentsSection() {
  return (
    <section id="comments" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950">
            读者热评
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            听听漫友们怎么说——真实读者的下拉式阅读体验分享
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {commentItems.slice(0, 3).map((item) => (
            <div
              key={item.id}
              className="bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/60"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-11 h-11 rounded-full overflow-hidden flex-shrink-0">
                  <img
                    src={item.avatar}
                    alt={item.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div>
                  <div className="font-semibold text-sm text-foreground-950">{item.name}</div>
                  <div className="text-xs text-foreground-400">{item.time}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{item.content}</p>
              <div className="mt-4 flex items-center gap-1 text-accent-500 text-xs">
                <i className="ri-heart-fill" />
                <span className="font-medium">{item.likes.toLocaleString()}</span>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {commentItems.slice(3, 5).map((item) => (
            <div
              key={item.id}
              className="bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/60"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-11 h-11 rounded-full overflow-hidden flex-shrink-0">
                  <img
                    src={item.avatar}
                    alt={item.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div>
                  <div className="font-semibold text-sm text-foreground-950">{item.name}</div>
                  <div className="text-xs text-foreground-400">{item.time}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{item.content}</p>
              <div className="mt-4 flex items-center gap-1 text-accent-500 text-xs">
                <i className="ri-heart-fill" />
                <span className="font-medium">{item.likes.toLocaleString()}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}